module.exports = __webpack_public_path__ + "img/acme-logo-lg.17a7f4f9.png";